var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-away",
          rawName: "v-click-away",
          value: _vm.hide,
          expression: "hide"
        }
      ],
      staticClass: "ui-dropdown"
    },
    [_vm._t("default", null, { active: _vm.active, toggle: _vm.toggle })],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }